{
  "web_Couldn’t load this conversation. Try again.": "Couldn’t load this conversation. Try again.",
  "1_approval_waiting": "1 approval waiting",
  "1_hour": "1 hour",
  "30_days": "30 days",
  "7_days": "7 days",
  "a_chat": "A chat",
  "a_document_this_version_can_t_show": "A document this version can't show",
  "a_new_agent_has_none_until_it_runs": "A new agent has none until it runs.",
  "a_new_project_gets_its_own_folder_for_the_agent_s_work": "A new project gets its own folder for the agent’s work.",
  "a_person_s_handle_chooses_their_default_assistant_an_assistan_88101ef7": "A person's handle chooses their default assistant. An assistant's handle chooses that exact assistant. Existing exchanges keep both chosen assistants.",
  "a_project": "A project",
  "a_published_agent_keeps_its_handle": "A published agent keeps its handle.",
  "a_revision_lasts_at_most_two_hours_of_a_run": "A revision lasts at most two hours of a run.",
  "a_short_name_up_to_80_characters": "A short name, up to 80 characters.",
  "a_skill_this_version_can_t_show": "A skill this version can't show",
  "a_sleeping_run_waits_until_it_wakes_a_stopped_chat_brings_the_bf1b159d": "A sleeping run waits until it wakes. A stopped chat brings the agent in when its next run starts.",
  "accept": "Accept",
  "access": "Access",
  "access_log": "Access Log",
  "action": "Action",
  "active": "Active",
  "activity": "Activity",
  "acts_as": "Acts as",
  "acts_in_hylo_as_itself_reads_chats_posts_remembers": "Acts in Hylo as itself: reads chats, posts, remembers.",
  "add": "Add",
  "add_a_heuristic": "Add a heuristic",
  "add_agent": "Add Agent",
  "add_agent_c68df2": "Add Agent…",
  "add_agent_from_project": "Add Agent from project",
  "add_an_assistant_to_a_chat": "Add an assistant to a chat",
  "add_assistant": "Add Assistant",
  "add_contact": "Add contact",
  "add_my_assistant": "Add My Assistant",
  "add_my_assistant_e503fc": "Add My Assistant…",
  "add_people": "Add People…",
  "add_reference": "Add Reference",
  "add_schedule": "Add Schedule…",
  "add_skill": "Add Skill",
  "addressed_messages": "Addressed messages",
  "addressed_to_this_conversation": "Addressed to this conversation",
  "agent": "Agent",
  "agent_definition": "Agent Definition",
  "agent_details": "Agent Details",
  "agent_library": "Agent library",
  "agent_settings_or_access_changed_refresh_to_see_what_is_in_effect": "Agent settings or access changed. Refresh to see what is in effect.",
  "agent_usage": "Agent Usage",
  "agents": "Agents",
  "agents_and_teams": "Agents & Teams",
  "agents_are_unavailable_right_now": "Agents are unavailable right now.",
  "agents_aren_t_on_for_your_account": "Agents aren't on for your account",
  "agents_can_read_change_and_delete_project_files_and_run_commands": "Agents can read, change and delete project files and run commands.",
  "agents_can_say_what_they_are_doing_what_they_say_clears_by_it_b47919bd": "Agents can say what they are doing. What they say clears by itself after a while.",
  "agents_will_work_directly_in_they_can_change_and_delete_files_b527b91d": "Agents will work directly in {{value}}: they can change and delete files and run commands.",
  "agents_work_directly_in_the_folder_you_attach_they_can_change_62ead00f": "Agents work directly in the folder you attach: they can change and delete files and run commands. Prefer a git worktree or a scratch copy.",
  "alert": "Alert",
  "all_agents_in_this_run_use_the_same_working_folder": "All agents in this run use the same working folder.",
  "all_assistants_you_own": "All assistants you own",
  "all_members": "All members",
  "all_messages": "All messages",
  "all_owners": "All owners",
  "all_providers": "All providers",
  "all_root_folders": "All root folders",
  "all_suggestions": "All suggestions",
  "all_teams": "All teams",
  "allow_changing_my_items": "Allow changing my items",
  "allow_reading_my_items_and_calendar": "Allow reading my items and calendar",
  "allow_reads_as_you_only_while_the_assistant_works_in_your_pri_6a83c0c0": "Allow reads as you only while the assistant works in your private chat, or while it works in any chat it's in. Left out chats and projects stay excluded. The assistant never writes as you.",
  "allow_routing_by_labels": "Allow routing by labels",
  "always_ask_me": "Always ask me",
  "an_account": "An account",
  "an_agent_mentions_me": "An agent mentions me",
  "an_agent_posts": "An agent posts",
  "an_agent_you_can_use_is_already_named": "An agent you can use is already named “{{value}}”.",
  "an_approved_assistant_change_wasn_t_applied": "An approved assistant change wasn't applied",
  "an_execution_mode_defined_by_this_server": "An execution mode defined by this server.",
  "an_item": "An item",
  "and_are_thinking": "{{value1}} and {{value2}} are thinking…",
  "another_team_chat_in_this_project_uses_the_project_folder_tea_32b19cd8": "Another Team chat in this project uses the project folder. Teams may overwrite each other’s handoff files.",
  "answer_choices_read_only": "Answer choices (read-only)",
  "answers_are_enabled_only_while_the_original_question_is_active": "Answers are enabled only while the original question is active.",
  "answers_use_free_text": "Answers use free text.",
  "applied_an_approved_assistant_change": "Applied an approved assistant change",
  "applies_from_the_next_run": "Applies from the next run",
  "applies_to": "Applies to",
  "apply": "Apply",
  "apply_now_restart": "Apply Now (Restart)",
  "approvals_couldn_t_be_checked": "Approvals couldn't be checked",
  "approve": "Approve",
  "approve_to_share_this_exact_text_with_both_owners_and_assista_536cec9b": "Approve to share this exact text with both owners and assistants in the shared chat.",
  "approved_waiting_to_apply_your_change": "Approved. Waiting to apply your change.",
  "ask_a_member_to_bring_an_assistant": "Ask a member to bring an assistant",
  "ask_a_person": "Ask a person",
  "ask_me_when_it_used_my_private_data": "Ask me when it used my private data",
  "ask_the_people_who_run_this_server_to_turn_agents_on_for_you": "Ask the people who run this server to turn agents on for you.",
  "asked_to_bring_their_assistant": "Asked {{value}} to bring their assistant",
  "asked_you_to_bring_your_assistant": "{{value}} asked you to bring your assistant",
  "asks_another_model_claude_codex_gemini_for_a_review_or_a_seco_ad8273f4": "Asks another model (Claude, Codex, Gemini) for a review or a second opinion.",
  "assistant": "Assistant",
  "assistant_exchange": "Assistant Exchange",
  "assistant_exchanges": "Assistant Exchanges",
  "assistant_limits": "Assistant limits",
  "assistant_name": "Assistant name",
  "assistants": "Assistants",
  "at": "At",
  "at_its_times_a_schedule_posts_its_message_to_the_agents_as_yo_9edcc3fd": "At its times a schedule posts its message to the agents as yours. Agents can set their own wake-ups.",
  "at_most_every": "At Most Every",
  "attach": "Attach: {{value}}",
  "attach_a_folder": "Attach a Folder",
  "attach_a_folder_3b55a9": "Attach a folder…",
  "attach_this_folder": "Attach this folder",
  "attach_this_path": "Attach this path",
  "attached": "Attached",
  "attached_folder": "Attached folder",
  "automatic": "Automatic",
  "avatar": "Avatar",
  "before_posting_in_chats_with_other_people": "Before posting in chats with other people",
  "bio": "Bio",
  "blocked": "Blocked",
  "both_owners_must_approve_this_sets_reminders_in_hylo_it_does_a4e546f1": "Both owners must approve. This sets reminders in Hylo; it does not book a calendar.",
  "both_owners_must_approve_to_create_a_shared_project_and_task_d1ab8b8b": "Both owners must approve to create a shared project and task chat. Assistants work through the shared chat.",
  "brief": "Brief",
  "briefing": "Briefing",
  "bring_into_the_chat_now": "Bring into the chat now",
  "browse_files": "Browse Files",
  "budget_reached": "Budget reached",
  "builtin": "Builtin",
  "by_an_agent": "{{value}} · by an agent",
  "cached_authority": "Refresh to confirm your current access.",
  "calendar": "Calendar",
  "calendar_days_in_utc_including_today": "Calendar days in UTC, including today.",
  "can_see_here": "Can see here",
  "cancel": "Cancel",
  "cancel_reminder": "Cancel reminder",
  "cancelled": "Cancelled",
  "change_access": "Change access",
  "change_agent": "Change Agent…",
  "change_assistant_access": "Change assistant access",
  "change_assistant_exchange_permission": "Change assistant exchange permission",
  "change_assistant_in_this_chat": "Change assistant in this chat",
  "change_assistant_pause": "Change assistant pause",
  "change_assistant_profile": "Change assistant profile",
  "change_assistant_schedule": "Change assistant schedule",
  "change_daily_assistant_limit": "Change daily assistant limit",
  "change_default_assistant": "Change default assistant",
  "change_event_responses": "Change event responses",
  "change_item_and_calendar_access": "Change item and calendar access",
  "change_model": "Change Model…",
  "change_model_bb38c9": "Change model",
  "change_photo": "Change photo…",
  "changes": "Changes",
  "changes_to_this_library_character_reach_the_chat_at_the_agent_52258c90": "Changes to this library character reach the chat at the agent's next turn.",
  "changing_items_requires_reading_access_your_assistant_also_ne_fea23c7d": "Changing items requires reading access. Your assistant also needs the reading permission in Access.",
  "changing_this_name_requires_permission_to_post_in_an_active_chat": "Changing this name requires permission to post in an active chat.",
  "character": "Character",
  "character_actions": "Character actions",
  "character_source_unavailable": "Character source unavailable",
  "character_this_chat": "Character · This chat",
  "character_unavailable": "Character unavailable",
  "characters": "Characters",
  "characters_give_agents_a_voice_values_and_a_way_of_speaking": "Characters give agents a voice, values and a way of speaking.",
  "chat": "Chat",
  "chat_assistants": "Chat assistants",
  "chat_limits": "Chat limits",
  "chat_name": "Chat name",
  "chat_or_project": "Chat or project",
  "chats": "Chats",
  "chats_you_muted_or_set_to_mentions_only_stay_as_quiet_for_you_c774dd4b": "Chats you muted or set to mentions only stay as quiet for your assistant. Events that come close together go as one list.",
  "check_again": "Check Again",
  "check_the_working_folder_before_starting_another_team": "Check the working folder before starting another Team.",
  "check_your_connection_then_try_again": "Check your connection, then try again.",
  "checked_your_mentions": "Checked your mentions",
  "chinese_description": "Chinese description",
  "chinese_name": "Chinese name",
  "choose_an_organization": "Choose an organization",
  "choose_assistant": "Choose Assistant",
  "choose_at_least_one_day": "Choose at least one day.",
  "choose_from_character_library": "Choose from Character Library…",
  "choose_photo": "Choose Photo…",
  "class_scope": "Class scope",
  "claw_decides_from_the_provider": "claw decides from the provider.",
  "claw_s_reference_files": "claw's reference files",
  "clear": "Clear",
  "clears_at": "Clears at {{value}}",
  "co_owner": "Co-owner",
  "collaboration": "Collaboration",
  "compact_the_session_at": "Compact the session at",
  "completed": "Completed",
  "connection_created": "Connection Created",
  "connection_unknown": "The result could not be confirmed. Refresh connections before creating another.",
  "connections": "Connections",
  "contact": "Contact",
  "continue_once": "Continue once",
  "continue_once_leaves_these_caps_in_place": "Continue once leaves these caps in place.",
  "conversation": "Conversation",
  "copy_key": "Copy Key",
  "copy_url": "Copy URL",
  "core_memory_is_shared_with_your_primary_assistant_and_is_read_75875109": "Core memory is shared with your primary assistant and is read only. This specialist keeps its project notes and journal in its own home.",
  "couldn_t_confirm_this_change_try_again_to_check_the_same_request": "Couldn't confirm this change. Try again to check the same request.",
  "couldn_t_load_agents_and_teams": "Couldn't load Agents & Teams",
  "couldn_t_load_characters": "Couldn't load characters",
  "couldn_t_load_every_project_s_chats": "Couldn't load every project's chats.",
  "couldn_t_load_item_and_calendar_access": "Couldn't load item and calendar access.",
  "couldn_t_load_the_access_log": "Couldn't load the access log.",
  "couldn_t_load_the_chats_your_assistant_is_in": "Couldn't load the chats your assistant is in.",
  "couldn_t_load_the_picture": "Couldn't load the picture.",
  "couldn_t_load_this_specialist": "Couldn't load this specialist.",
  "couldn_t_load_what_is_in_effect": "Couldn’t load what is in effect.",
  "couldn_t_load_your_assistant_s_access": "Couldn't load your assistant's access.",
  "couldn_t_load_your_assistant_s_settings": "Couldn't load your assistant's settings.",
  "couldn_t_load_your_projects": "Couldn't load your projects.",
  "couldn_t_load_your_specialists": "Couldn't load your specialists.",
  "couldn_t_set_up": "Couldn't set up",
  "couldn_t_update_this_budget_card": "Couldn't update this budget card.",
  "counts_the_runs_your_assistant_starts_on_its_own_for_its_sche_5d9ba2b2": "Counts the runs your assistant starts on its own, for its schedule and your account's events. Runs you start never count. Over the limit they wait until {{value}}, or until you raise it.",
  "create": "Create",
  "create_a_chat": "Create a chat",
  "create_an_assistant": "Create an assistant",
  "create_chat": "Create Chat",
  "created": "Created",
  "creative": "Creative",
  "cron_expression": "Cron expression",
  "current_permissions_and_exclusions_apply": "Current permissions and exclusions apply.",
  "custom": "Custom",
  "custom_cron": "Custom (cron)",
  "custom_schedule": "Custom schedule",
  "daily_limits": "Daily limits",
  "daily_run_limit": "Daily run limit",
  "daily_runs_lld": "Daily runs: {{count}}",
  "day": "Day",
  "decline": "Decline",
  "default": "Default",
  "delete_chat": "Delete Chat",
  "delete_schedule": "Delete Schedule",
  "deleted": "Deleted",
  "deleting": "Deleting…",
  "delivered": "Delivered",
  "delivery_attempts_were_exhausted": "Delivery attempts were exhausted.",
  "delivery_id": "Delivery ID",
  "description": "Description",
  "destination": "Destination",
  "details": "Details",
  "development": "Development",
  "direct_messages": "Direct Messages",
  "direct_messages_e7596a": "Direct messages",
  "discard_changes": "Discard Changes",
  "discussion_and_debate": "Discussion & debate",
  "dismiss": "Dismiss",
  "dismiss_helpers": "Dismiss helpers",
  "display_name": "Display name",
  "distillation": "Distillation",
  "document": "Document",
  "done": "Done",
  "draft": "Draft",
  "drafts": "Drafts",
  "due": "Due",
  "duplicate": "Duplicate",
  "edit": "Edit",
  "edit_assistant": "Edit Assistant",
  "edit_b45435": "Edit…",
  "edit_chat": "Edit chat",
  "edit_json": "Edit JSON",
  "edit_schedule": "Edit Schedule",
  "edit_schedule_de6cc4": "Edit Schedule…",
  "edit_suggestion": "Edit suggestion",
  "edit_these_in_advanced": "Edit these in Advanced.",
  "edited_a_suggestion": "Edited a suggestion",
  "editing_this_character_reaches_the_agents_and_chats_using_it_56f61b0d": "Editing this character reaches the agents and chats using it at their next turn.",
  "effect": "Effect",
  "effort": "Effort",
  "enabled": "Enabled",
  "end_is_exclusive": "End is exclusive",
  "ended": "Ended",
  "ended_after_a_long_idle": "Ended after a long idle",
  "ended_the_run_failed": "Ended: the run failed",
  "ended_the_run_was_lost": "Ended: the run was lost",
  "ends": "Ends",
  "engine": "Engine",
  "engine_unreachable": "Engine unreachable",
  "enter_whole_numbers_from_0_to_1_000_000_000_or_leave_fields_blank": "Enter whole numbers from 0 to 1,000,000,000, or leave fields blank.",
  "estimated_start": "Estimated start",
  "event_revision": "Event revision",
  "event_time_source_zone": "Event time · source zone",
  "event_time_your_zone": "Event time · your zone",
  "event_types": "Event types",
  "every": "Every…",
  "every_day": "Every Day",
  "every_day_at": "Every day at {{value}}",
  "every_hour": "Every hour",
  "every_lld_hours": "Every {{count}} hours",
  "every_lld_minutes": "Every {{count}} minutes",
  "every_message": "Every message",
  "every_message_not_addressed_to_someone_else": "Every message not addressed to someone else",
  "everyone": "Everyone",
  "everyone_here": "Everyone here",
  "everyone_here_directs_the_agents": "Everyone here directs the agents.",
  "everyone_in_this_chat_sees_this_name": "Everyone in this chat sees this name.",
  "everyone_will_see_this_agent_s_default_orb": "Everyone will see this agent's default orb.",
  "exchange": "Exchange",
  "exclude_a_chat_or_project": "Exclude a chat or project",
  "execution": "Execution",
  "expected_by": "Expected by {{value}}",
  "failed": "Failed",
  "file": "File",
  "files": "Files",
  "files_shared_with_me": "Files Shared with Me",
  "find_it_in_the_chat_s_members": "Find it in the chat's members.",
  "five_fields_minute_hour_day_of_month_month_day_of_week_0_or_7_91b62b11": "Five fields: minute, hour, day of month, month, day of week (0 or 7 is Sunday). For example: */30 9-17 * * 1-5.",
  "folder": "Folder",
  "folder_unavailable": "Folder unavailable",
  "folds_the_day_s_notes_into_your_assistant_s_memory_skipped_on_de7c7948": "Folds the day's notes into your assistant's memory. Skipped on a day you didn't talk to it.",
  "follow_chat_settings": "Follow chat settings",
  "follow_my_chat_notifications": "Follow My Chat Notifications",
  "follow_up": "Follow up",
  "from_character_library": "From character library",
  "from_my_documents": "From My Documents…",
  "full": "Full",
  "generate": "Generate…",
  "give_assistant_project_access": "Give assistant project access",
  "group_chat": "Group chat",
  "group_name": "Group name",
  "group_names_are_up_to_lld_characters": "Group names are up to {{count}} characters.",
  "handle": "Handle",
  "has_a_character": "Has a character",
  "has_no_assistant_available": "{{value}} has no assistant available",
  "helpers": "Helpers",
  "heuristics": "Heuristics",
  "hide": "Hide",
  "high": "High",
  "home_folder": "Home Folder",
  "hours": "Hours",
  "how_it_talks": "How it talks",
  "https_url": "HTTPS URL",
  "hylo_cli": "Hylo CLI",
  "hylo_offers_no_models_for_this_provider_its_brain_stays_as_it_is": "Hylo offers no models for this provider; its brain stays as it is.",
  "hylo_will_use_every_account_signs_out_and_its_chats_stay_on_t_a6986841": "Hylo will use {{value}}. Every account signs out, and its chats stay on this device for when you switch back.",
  "identity": "Identity",
  "in_1_hour": "In 1 hour",
  "in_30_minutes": "In 30 minutes",
  "in_chats": "In Chats",
  "in_each_chat_its_person_decides_who_directs_it_and_what_it_he_d36119f9": "In each chat, its person decides who directs it and what it hears. Stop it there, or remove it from the chat's info.",
  "in_effect": "In effect",
  "in_every_chat_it_s_in": "In every chat it's in",
  "in_this_chat": "In this chat",
  "inactive": "Inactive",
  "incoming_webhook": "Incoming Webhook",
  "info": "Info",
  "inherited_character": "Inherited character",
  "inspects_and_judges_runs": "Inspects and judges runs.",
  "installed_in_claw": "Installed in claw",
  "instructions_skills_and_brain": "Instructions, Skills & Brain",
  "interval_in_minutes": "Interval in minutes",
  "invitation_generation": "Invitation generation",
  "invitation_request": "Invitation request",
  "invitations": "Invitations",
  "invite_1_person": "Invite 1 person",
  "invited_1_person": "Invited 1 person",
  "invitee": "Invitee",
  "is_thinking": "{{value}} is thinking…",
  "it_leaves_the_chat_and_its_person_can_t_bring_it_back_until_y_ca92b11b": "It leaves the chat, and its person can't bring it back until you lift the ban under Bans.",
  "it_may_run_commands_and_use_its_provider_s_tools": "It may run commands and use its provider's tools.",
  "it_may_wake_itself_later_at_least_10_seconds_ahead": "It may wake itself later (at least 10 seconds ahead).",
  "it_only_talks_and_uses_claw_s_verbs": "It only talks and uses claw's verbs.",
  "it_reads_the_whole_chat": "It reads the whole chat.",
  "it_stops_answering_here_and_leaves_the_chat_its_person_can_br_31e7a0e9": "It stops answering here and leaves the chat. Its person can bring it back.",
  "it_stops_working_in_this_chat_and_leaves_once_it_has_stopped_aab76898": "It stops working in this chat and leaves once it has stopped. Adding it again starts it fresh.",
  "item": "Item",
  "item_and_calendar_access_saved": "Item and calendar access saved.",
  "items_and_calendar": "Items and Calendar",
  "its_key_stops_working_create_another_connection_to_replace_it": "Its key stops working. Create another connection to replace it.",
  "its_owner_s_chats_allowed_by_grants": "Its owner’s chats allowed by grants",
  "its_owner_s_readable_chats_and_projects": "Its owner’s readable chats and projects",
  "its_run_started_before_agents_could_be_added_here_stop_it_and_2797ccb4": "Its run started before agents could be added here. Stop it and restart it, then add agents.",
  "itself": "Itself · {{value}}",
  "job": "Job",
  "joining": "Joining…",
  "joins_when_the_leader_brings_it_in": "Joins when the leader brings it in",
  "keep_it_under_lld_characters": "Keep it under {{count}} characters.",
  "keep_my_changed_fields": "Keep my changed fields",
  "last_time_skipped_nothing_to_do": "Last time skipped: nothing to do",
  "last_time_skipped_the_agents_weren_t_running": "Last time skipped: the agents weren't running",
  "last_time_skipped_the_chat_was_stopped": "Last time skipped: the chat was stopped",
  "last_time_skipped_the_previous_message_was_still_waiting": "Last time skipped: the previous message was still waiting",
  "last_turn": "Last Turn",
  "leader": "Leader",
  "lean_effort": "Lean effort",
  "leans_to_effort": "Leans to effort",
  "leave_a_field_blank_for_no_limit_zero_holds_new_runs_days_and_c8c0f703": "Leave a field blank for no limit. Zero holds new runs. Days and months reset at midnight UTC.",
  "leave_chat": "Leave Chat",
  "leave_chats_or_projects_out": "Leave chats or projects out",
  "leave_out": "Leave Out",
  "leave_out_lld": "Leave Out {{count}}",
  "leave_this_chat": "Leave this chat?",
  "left_out": "Left out",
  "let_friends_and_org_members_assistants_reach_mine": "Let friends' and org members' assistants reach mine",
  "let_your_assistant_read_again": "Let your assistant read {{value}} again",
  "library_character": "Library character",
  "limits": "Limits",
  "limits_saved": "Limits saved.",
  "listed_suggestions": "Listed suggestions",
  "listed_your_chats": "Listed your chats",
  "listed_your_contacts": "Listed your contacts",
  "listed_your_organizations": "Listed your organizations",
  "listed_your_projects": "Listed your projects",
  "live_teams": "Live teams",
  "lld_agents": "{{count}} agents",
  "lld_agents_are_thinking": "{{count}} agents are thinking…",
  "lld_agents_lld_members": "{{value1}} agents · {{value2}} members",
  "lld_approvals_waiting": "{{count}} approvals waiting",
  "lld_bytes": "{{count}} bytes",
  "lld_calls_include_estimates": "{{count}} calls include estimates",
  "lld_calls_without_cost": "{{count}} calls without cost",
  "lld_calls_without_model_time": "{{count}} calls without model time",
  "lld_calls_without_token_counts": "{{count}} calls without token counts",
  "lld_characters": "{{count}} characters",
  "lld_characters_left": "{{count}} characters left",
  "lld_from_you_lld_from_agent": "{{value1}} from you, {{value2}} from agent",
  "lld_of_lld_bytes": "{{value1}} of {{value2}} bytes",
  "lld_others_are_thinking": "{{count}} others are thinking…",
  "lld_people_lld_agents": "{{value1}} people · {{value2}} agents",
  "lld_runs_have_unavailable_history_cached_usage_remains_available": "{{count}} runs have unavailable history. Cached usage remains available.",
  "lld_runs_lld_model_calls_lld_tokens": "{{value1}} runs · {{value2}} model calls · {{value3}} tokens",
  "lld_runs_still_need_older_usage": "{{count}} runs still need older usage.",
  "load_earlier_activity": "Load earlier activity",
  "load_latest": "Load latest",
  "load_more": "Load more",
  "load_older_usage": "Load older usage",
  "load_the_current_event_and_people_to_review_this_suggestion": "Load the current event and people to review this suggestion.",
  "loading": "Loading…",
  "loading_what_is_in_effect": "Loading what is in effect",
  "location": "Location",
  "looked_up_an_account": "Looked up an account",
  "low": "Low",
  "make_default": "Make Default",
  "manage_as_admin": "Manage as admin",
  "manage_connections": "Manage Connections",
  "managed_folder": "Managed folder",
  "may_ask_people": "May ask people",
  "may_recruit_helpers": "May recruit helpers",
  "may_revise_its_own_character": "May revise its own character",
  "may_stop_the_run": "May stop the run",
  "maybe": "Maybe",
  "meet_your_own_ai_assistant_ask_it_anything_hand_it_tasks_and_af213e47": "Meet your own AI assistant. Ask it anything, hand it tasks, and let it remember what matters to you: it keeps its memory in its own folder and works only for you. It never sends anything in your name without your approval. Its chat is pinned at the top of Home.",
  "meeting_agreement": "Meeting agreement",
  "meeting_suggestion": "Meeting suggestion",
  "member_scope": "Member scope",
  "member_you_ask": "Member you ask",
  "members": "Members",
  "memory": "Memory",
  "memory_files_loaded_by_the_cli_unknown": "Memory files loaded by the CLI: Unknown",
  "memory_it_may_read_and_write": "Memory it may read and write",
  "mentions": "Mentions",
  "mentions_and_replies_addressed_to_it": "Mentions and replies addressed to it.",
  "mentions_of_me": "Mentions of Me",
  "messages_this_assistant_hears": "Messages this assistant hears",
  "messages_to_it": "Messages to it",
  "mine": "Mine",
  "minutes": "Minutes",
  "model": "Model",
  "model_and_effort": "Model and effort",
  "model_and_effort_require_permission_to_post_and_a_model_offer_faa2bd40": "Model and effort require permission to post and a model offered by this agent's provider.",
  "model_calls": "Model calls",
  "model_time": "Model time",
  "monthly_limits": "Monthly limits",
  "more_approvals_may_be_waiting_open_suggestions_or_an_assistan_a9bb48e1": "More approvals may be waiting. Open Suggestions or an assistant’s home to check the rest.",
  "more_approvals_may_be_waiting_this_list_can_show_only_the_fir_313bfece": "More approvals may be waiting. This list can show only the first 100 peer approvals.",
  "more_folders": "More folders",
  "morning_briefing": "Morning Briefing",
  "morning_briefing_0da62b": "Morning briefing",
  "mutation_epoch": "Mutation epoch",
  "my_organization": "My organization",
  "name": "Name",
  "name_in_this_chat": "Name in this chat",
  "name_optional": "Name (optional)",
  "never": "Never",
  "new": "New",
  "new_agent": "New Agent",
  "new_agent_86cdec": "New agent: {{value}}",
  "new_agent_chat": "New Agent Chat",
  "new_agent_with_ai": "New Agent with AI",
  "new_character": "New Character",
  "new_members_can_see_earlier_messages": "New members can see earlier messages",
  "new_project": "New project",
  "new_schedule": "New Schedule",
  "new_specialist": "New Specialist…",
  "new_team": "New Team",
  "new_team_chat": "New Team Chat",
  "new_team_with_ai": "New Team with AI",
  "next_run": "Next run",
  "next_run_it_takes_effect_on_the_next_run": "Next run: {{value}}. It takes effect on the next run.",
  "next_step": "Next step",
  "nightly_memory_distillation": "Nightly Memory Distillation",
  "nightly_memory_distillation_b7018e": "Nightly memory distillation",
  "no_access": "No access",
  "no_activity_yet": "No activity yet.",
  "no_agent_is_at_work_right_now": "No agent is at work right now.",
  "no_agent_is_available_to_you_right_now": "No agent is available to you right now.",
  "no_agent_usage_in_this_period": "No agent usage in this period.",
  "no_agents_match": "No agents match.",
  "no_agents_yet": "No agents yet",
  "no_agreements_waiting": "No agreements waiting.",
  "no_approvals_waiting_lld_expired": "No approvals waiting · {{count}} expired",
  "no_characters_yet": "No characters yet",
  "no_collaboration_messages_available": "No collaboration messages available.",
  "no_connections_yet": "No connections yet.",
  "no_deliveries_yet": "No deliveries yet.",
  "no_exchanges_for_this_assistant_yet": "No exchanges for this assistant yet.",
  "no_folders_here": "No folders here.",
  "no_instructions_yet": "No instructions yet",
  "no_library_character": "No library character",
  "no_photo": "No photo",
  "no_ready_assistants_are_available_to_add": "No ready assistants are available to add.",
  "no_references_yet": "No references yet.",
  "no_scheduled_time": "No scheduled time",
  "no_schedules": "No schedules.",
  "no_shell_or_native_tools": "No shell or native tools",
  "no_skills_of_its_own_yet": "No skills of its own yet.",
  "no_suggestions_to_review": "No suggestions to review.",
  "no_teams_yet": "No teams yet",
  "no_visible_agents_or_chats_use_this_character_yet": "No visible agents or chats use this character yet.",
  "none": "None",
  "normal": "Normal",
  "not_in_this_run": "Not in this run",
  "not_joined": "Not joined",
  "not_now": "Not Now",
  "not_now_e45714": "Not now",
  "not_reported": "Not reported",
  "not_running": "Not running",
  "not_saved_your_choices_are_still_shown_check_your_connection_df6cee22": "Not saved. Your choices are still shown. Check your connection or access, then save again.",
  "not_set": "Not set",
  "not_specified": "Not specified",
  "not_started": "Not started",
  "notes_are_up_to_lld_characters": "Notes are up to {{count}} characters.",
  "nothing_is_left_out_chats_and_projects_you_add_here_are_never_985ca015": "Nothing is left out. Chats and projects you add here are never read as you.",
  "nothing_matches": "Nothing matches",
  "nothing_more_to_leave_out": "Nothing more to leave out.",
  "nothing_stored_yet_or_the_engine_can_t_read_it": "Nothing stored yet, or the engine can't read it.",
  "notify_when": "Notify when",
  "of_the_window": "¾ of the window",
  "off": "Off",
  "off_this_run_s_own_workspace_on_the_project_folder_shared_by_fa4d33dc": "Off: this run’s own workspace. On: the project folder shared by this project’s agents. Changes apply from the next run.",
  "offline_action": "Connect to make this change.",
  "offline_cached": "Offline — showing the last loaded information.",
  "ok": "OK",
  "on": "On",
  "on_behalf_of": "On behalf of {{value}}",
  "one_agent_is_one_account_in_every_chat": "One agent is one account, in every chat",
  "only_add_people_you_trust_anyone_you_add_can_direct_this_chat_302d39cf": "Only add people you trust. Anyone you add can direct this chat's agents, which work without limits on the agent engine: through them, they can reach its data, sign-ins and other projects. They also become an editor of the project {{value}} and can open its folder, including the agents' earlier work.",
  "only_asks_their_assistant_here": "Only {{value}} asks their assistant here",
  "only_for_you_hidden_messages_still_count_as_read": "Only for you. Hidden messages still count as read.",
  "only_in_our_private_chat": "Only in our private chat",
  "only_its_owner_can_read_what_it_remembers": "Only its owner can read what it remembers.",
  "only_its_person": "Only its person",
  "only_me": "Only me",
  "only_the_assistant_s_owner_can_change_its_name_model_and_effort": "Only the assistant's owner can change its name, model and effort.",
  "only_the_latest_are_shown": "Only the latest are shown.",
  "only_while_the_agents_are_running": "Only while the agents are running",
  "only_you": "Only you",
  "only_your_own_requests_may_use_your_private_information": "Only your own requests may use your private information.",
  "open": "Open",
  "open_an_assistant_exchange": "Open an assistant exchange",
  "open_character": "Open character",
  "open_chat": "Open Chat",
  "open_event": "Open event",
  "open_item": "Open item",
  "opened_an_attachment": "Opened an attachment",
  "opens_the_admin_editor_for_this_agent_the_owner_can_see_chang_22577d50": "Opens the admin editor for this agent. The owner can see changes you make.",
  "optional_lld_characters_left": "Optional. {{count}} characters left.",
  "or_type_a_path": "Or type a path",
  "organization": "Organization",
  "organizer": "Organizer",
  "other": "Other",
  "other_access": "Other access",
  "other_verbs": "Other verbs",
  "other_wakes": "Other wakes",
  "others_responded_since_this_suggestion_approval_may_be_refused": "Others responded since this suggestion; approval may be refused.",
  "otherwise_a_message_that_finds_the_agents_run_ended_starts_a_05ec7efe": "Otherwise a message that finds the agents' run ended starts a new one, as Restart would.",
  "outgoing_notification": "Outgoing Notification",
  "owner": "Owner",
  "owner_only": "Owner only",
  "owners_and_editors": "Owners and editors",
  "owners_only": "Owners only",
  "partial_inbox": "Some assistants could not be checked. The list may be incomplete.",
  "paste_a_document": "Paste a Document…",
  "pasted": "Pasted",
  "pause": "Pause",
  "pause_assistant": "Pause assistant",
  "paused": "Paused",
  "paused_your_assistant_can_t_read_or_do_anything_until_you_resume_it": "Paused: your assistant can't read or do anything until you resume it.",
  "pausing_stops_everything_your_assistant_does_at_once_and_its_163798af": "Pausing stops everything your assistant does at once, and its access keys stop working.",
  "peer_agreements": "Peer agreements",
  "peer_assistant": "Peer assistant",
  "peer_owner": "Peer owner",
  "pending": "Pending",
  "people_added_from_now_on_read_this_chat_from_when_they_join": "People added from now on read this chat from when they join.",
  "people_added_from_now_on_read_this_chat_s_earlier_messages": "People added from now on read this chat's earlier messages.",
  "people_bring_their_own_assistants_each_answers_when_it_is_add_e7a02a99": "People bring their own assistants. Each answers when it is addressed, as its person allows.",
  "people_in_this_chat": "People in this chat",
  "people_it_is_shared_with_can_use_and_duplicate_it_only_you_edit_it": "People it is shared with can use and duplicate it. Only you edit it.",
  "period": "Period",
  "permissions": "Permissions",
  "person": "Person",
  "person_or_assistant_handle": "Person or assistant handle",
  "photo": "Photo",
  "pick_a_time": "Pick a time",
  "policy_revision": "Policy revision",
  "post_as_assistant": "Post as Assistant",
  "posted_to_the_agents_as_your_message_date_weekday_and_time_be_9f87faec": "Posted to the agents as your message. {date}, {weekday} and {time} become that time's date, weekday and time.",
  "preparing_its_own_home_and_chat": "Preparing its own home and chat…",
  "priority": "Priority",
  "private_home": "Private home",
  "private_suggestion_nothing_happens_until_you_approve": "Private suggestion. Nothing happens until you approve.",
  "project": "Project",
  "project_access": "Project access",
  "project_memory": "Project Memory",
  "project_names_are_up_to_lld_characters": "Project names are up to {{count}} characters.",
  "project_scope": "Project scope",
  "projects": "Projects",
  "proposed_photo": "Proposed photo",
  "provided": "Provided",
  "provider": "Provider",
  "provider_changes_apply_from_the_next_run": "Provider changes apply from the next run.",
  "publishing_adds_it_when_the_agent_has_skills": "Publishing adds it when the agent has skills.",
  "queued_for_the_agents": "Queued for the agents",
  "raise_the_limit": "Raise the limit",
  "read": "Read",
  "read_a_message": "Read a message",
  "read_a_project_s_brief_and_pins": "Read a project's brief and pins",
  "read_a_suggestion": "Read a suggestion",
  "read_and_write": "Read and write",
  "read_and_write_memory": "Read and write memory",
  "read_assistant_settings": "Read assistant settings",
  "read_messages": "Read messages",
  "read_only": "Read only",
  "read_only_studio": "Studio editing is not available on the web yet.",
  "read_project_files": "Read project files",
  "read_project_memory": "Read project memory",
  "read_what_i_can_read": "Read what I can read",
  "ready": "Ready",
  "realm_agents": "Realm agents",
  "recent_deliveries": "Recent Deliveries",
  "recipient": "Recipient",
  "recorded_facts_link_to_last_turn_unknown_means_there_is_no_re_475f2b0c": "Recorded facts link to Last Turn. Unknown means there is no readable evidence yet.",
  "recruit_helpers": "Recruit helpers",
  "refresh": "Refresh",
  "refresh_review": "Refresh review",
  "remind_at": "Remind at",
  "reminder": "Reminder",
  "reminder_id": "Reminder ID",
  "reminder_note": "Reminder note",
  "reminder_recipient": "Reminder recipient",
  "reminder_timing": "Reminder timing",
  "remove": "Remove",
  "remove_access": "Remove access",
  "remove_an_access_exclusion": "Remove an access exclusion",
  "remove_an_assistant_from_a_chat": "Remove an assistant from a chat",
  "remove_and_ban": "Remove and Ban",
  "remove_and_ban_this_assistant": "Remove and ban this assistant?",
  "remove_assistant_photo": "Remove Assistant Photo",
  "remove_assistant_project_access": "Remove assistant project access",
  "remove_from_chat": "Remove from Chat",
  "remove_from_this_chat": "Remove from this chat?",
  "remove_photo": "Remove Photo",
  "remove_photo_c8f5ed": "Remove photo",
  "remove_this_assistant_from_the_chat": "Remove this assistant from the chat?",
  "removing": "Removing…",
  "rename": "Rename",
  "rename_94ac9a": "Rename…",
  "rename_assistant": "Rename Assistant",
  "rename_assistant_28dd7a": "Rename Assistant…",
  "rename_chat": "Rename chat",
  "repeat": "Repeat",
  "repeat_at_most_every_5_minutes": "Repeat at most every 5 minutes.",
  "repeats": "Repeats",
  "replies": "Replies",
  "replies_to_my_messages": "Replies to My Messages",
  "reply": "Reply",
  "reply_to_message": "Reply to message",
  "reported_cost": "Reported cost",
  "request_message": "Request message",
  "require_my_approval_before_changes": "Require my approval before changes",
  "research": "Research",
  "reset": "Reset",
  "reset_the_character_in_this_chat": "Reset the character in this chat?",
  "response": "Response",
  "restart": "Restart",
  "restart_this_chat_to_add_agents": "Restart this chat to add agents",
  "resume": "Resume",
  "resume_assistant_creation": "Resume Assistant Creation",
  "resume_assistant_in_this_chat": "Resume assistant in this chat",
  "resume_exchange_opening": "Resume Exchange Opening",
  "resuming": "Resuming",
  "retry": "Retry",
  "retry_assistant_setup": "Retry assistant setup",
  "retry_keeps_the_same_assistant_and_choices_until_the_result_is_known": "Retry keeps the same assistant and choices until the result is known.",
  "retry_keeps_the_same_assistant_peer_and_request_until_the_res_f5d5fff4": "Retry keeps the same assistant, peer and request until the result is known.",
  "review": "Review",
  "revise_its_character": "Revise its character",
  "revision_lld": "Revision {{count}}",
  "revoke": "Revoke",
  "revoke_connection": "Revoke Connection",
  "revoke_this_connection": "Revoke this connection?",
  "revoked": "Revoked",
  "role": "Role",
  "role_guidance": "Role guidance",
  "role_notes_are_unavailable_in_this_legacy_chat": "Role notes are unavailable in this older chat.",
  "role_prompt_markdown": "Role prompt (Markdown)",
  "root_folders": "Root folders",
  "run": "Run",
  "run_control": "Run control",
  "run_lld": "Run {{count}}",
  "run_status_changed": "Run status changed",
  "run_status_changed_cdd829": "Run status changed: {{value1}} → {{value2}}",
  "running": "Running",
  "runs": "Runs",
  "runs_a_day": "Runs a Day",
  "runs_and_traces": "Runs and Traces",
  "runs_per_day": "Runs per day",
  "runs_per_month": "Runs per month",
  "s_agent": "{{value}}’s agent",
  "s_assistant": "{{value}}'s assistant",
  "s_assistant_ef16e2": "{{value}}’s assistant",
  "save": "Save",
  "save_changes": "Save Changes",
  "save_this_key_now_it_is_shown_only_once": "Save this key now. It is shown only once.",
  "saving_makes_a_new_version_for_you_to_review_approve_it_separ_f86ddce1": "Saving makes a new version for you to review. Approve it separately afterward.",
  "schedule": "Schedule",
  "schedule_b44a3b": "Schedule",
  "scheduled_a_wake_up": "{{value}} scheduled a wake-up",
  "scheduled_a_wake_up_for": "{{value1}} scheduled a wake-up for {{value2}}",
  "scheduled_a_wake_up_for_802552": "{{value1}} scheduled a wake-up for {{value2}}: {{value3}}",
  "scheduled_jobs": "Scheduled jobs",
  "schedules": "Schedules",
  "scope": "Scope",
  "search_agents": "Search agents",
  "search_characters": "Search characters",
  "search_chats": "Search chats",
  "search_projects": "Search projects",
  "search_teams": "Search teams",
  "searched_your_chats": "Searched your chats",
  "send_as_me": "Send as me",
  "send_external_events_to_this_chat_or_notify_another_service_w_15f74bca": "Send external events to this chat, or notify another service when its agents post.",
  "send_messages": "Send messages",
  "send_the_key_in_the_x_hylo_webhook_secret_header_with_a_json_0d5e7a76": "Send the key in the X-Hylo-Webhook-Secret header with a JSON or text POST. Inputs are labeled external and untrusted.",
  "sends_as_you": "Sends as you",
  "session": "Session",
  "set_before_owner_only_editing": "Set before owner-only editing",
  "set_by_its_owner": "Set by its owner",
  "set_by_you": "Set by you",
  "set_reminder": "Set reminder",
  "setting_up": "Setting up…",
  "settings": "Settings",
  "shapes_how_it_sounds_and_what_it_weighs_its_skills_and_tools_8e56b8cc": "Shapes how it sounds and what it weighs; its skills and tools stay its own. You can change it later.",
  "share": "Share",
  "share_information": "Share information",
  "shared": "Shared",
  "shared_with_me": "Shared with me",
  "shell_and_files": "Shell and files",
  "show": "Show",
  "show_all_agents": "Show All Agents",
  "showing_activity_from_lld_of_lld_agent_chats_open_a_chat_for_more": "Showing activity from {{value1}} of {{value2}} agent chats. Open a chat for more.",
  "shows_what_the_agent_is_made_of": "Shows what the agent is made of.",
  "signing_key": "Signing Key",
  "since": "Since {{value}}",
  "skill": "Skill",
  "skipped": "Skipped",
  "sleeping": "Sleeping",
  "snooze_reminder": "Snooze reminder",
  "some_assistants_are_unavailable_so_their_suggestions_can_t_be_d1156c28": "Some assistants are unavailable, so their suggestions can't be checked here.",
  "someone": "someone",
  "someone_here_already_asked_to_bring_their_assistant": "Someone here already asked {{value}} to bring their assistant",
  "someone_who_left": "someone who left",
  "specialists": "Specialists",
  "specialists_are_copies_of_your_assistant_for_one_kind_of_work_20c72f72": "Specialists are copies of your assistant for one kind of work, each with its own chat and memory. They share your core memory, read only.",
  "speech": "Speech",
  "speech_how_it_talks": "Speech: how it talks",
  "start_a_shared_task": "Start a shared task",
  "start_exchange": "Start Exchange",
  "start_from_a_character": "Start from a character",
  "starting": "Starting…",
  "starting_up": "Starting up",
  "starts": "Starts",
  "starts_later": "Starts later",
  "starts_with_fresh_memory_recurring_presets_off_and_its_own_re_964cc931": "Starts with fresh memory, recurring presets off, and its own reading controls enabled. Hylo reserves the next assistant handle for you.",
  "status": "Status",
  "step_1_lld_of_2_lld": "Step {{value1}} of {{value2}}",
  "stop": "Stop",
  "stop_an_assistant_exchange": "Stop an assistant exchange",
  "stop_assistant_in_this_chat": "Stop assistant in this chat",
  "stop_could_not_be_confirmed_contact_the_server_operator": "Stop could not be confirmed. Contact the server operator.",
  "stop_ends_what_it_is_doing_here_only_its_person_can_resume_it": "Stop ends what it is doing here. Only its person can resume it.",
  "stop_the_run": "Stop the run",
  "stopped": "Stopped",
  "stopped_at_its_message_limit": "Stopped at its message limit",
  "stopping": "Stopping…",
  "stored_memories": "Stored memories",
  "studio_isn_t_available_for_this_assistant_yet": "Studio isn't available for this assistant yet.",
  "studio_isn_t_on": "Studio isn't on",
  "suggested_an_action": "Suggested an action",
  "suggested_reply": "Suggested reply",
  "suggestions": "Suggestions",
  "suggestions_are_private_to_you_each_card_names_who_will_post_bf723354": "Suggestions are private to you. Each card names who will post; other actions use your permissions.",
  "suspended": "Suspended",
  "switch": "Switch",
  "switching": "Switching…",
  "system_skills_every_agent_shares_lld": "System skills every agent shares ({{count}})",
  "tags": "Tags",
  "takes_effect_from_the_agent_s_next_turn": "Takes effect from the agent's next turn.",
  "talk_and_claw_verbs_only": "Talk and claw verbs only",
  "target_type": "Target type",
  "team": "Team",
  "team_agent": "Team agent",
  "team_details": "Team Details",
  "team_events": "Team events",
  "team_scope": "Team scope",
  "teams": "Teams",
  "tell_my_assistant": "Tell My Assistant",
  "template_keys_such_as_role_keep_working": "Template keys such as {{role}} keep working.",
  "the_agent_brings_in_helpers_when_it_needs_them_and_anyone_her_72ed3361": "The agent brings in helpers when it needs them, and anyone here can add one; they join the chat before they speak.",
  "the_agent_catalog_is_unavailable": "The agent catalog is unavailable.",
  "the_agent_s_own": "The agent's own",
  "the_agent_you_choose_replaces_in_this_chat_now": "The agent you choose replaces {{value}} in this chat now.",
  "the_agents_and_teams_you_may_use_show_here": "The agents and teams you may use show here.",
  "the_assistant_s_automation_daily_budget_applies_separately": "The assistant's automation Daily Budget applies separately.",
  "the_assistant_s_run_waits_for_this_answer": "The assistant’s run waits for this answer.",
  "the_character_changed": "The character changed",
  "the_class_as_claw_runs_it": "The class as claw runs it",
  "the_delivery_could_not_be_completed": "The delivery could not be completed.",
  "the_destination_must_resolve_to_a_public_address": "The destination must resolve to a public address.",
  "the_destination_rejected_the_event": "The destination rejected the event.",
  "the_destination_timed_out": "The destination timed out.",
  "the_end_can_t_come_before_the_start": "The end can't come before the start.",
  "the_engine_can_t_be_reached_builtin_agents_and_teams_are_missing": "The engine can't be reached; builtin agents and teams are missing.",
  "the_engine_didn_t_answer_this_is_the_last_list_it_gave": "The engine didn't answer; this is the last list it gave.",
  "the_engine_refused_the_character": "The engine refused the character.",
  "the_engine_refused_the_switch_the_agent_keeps_its_model": "The engine refused the switch; the agent keeps its model.",
  "the_leader_brings_in_other_agents_when_it_needs_them_and_anyo_47b53aa2": "The leader brings in other agents when it needs them, and anyone here can add one; they join the chat before they speak.",
  "the_leader_is_in_the_chat_from_the_start_and_brings_in_the_ot_23261724": "The leader is in the chat from the start and brings in the others when it needs them.",
  "the_message_is_too_long": "The message is too long.",
  "the_server_has_not_provided_editable_model_settings_for_this_seat": "The server has not provided editable model settings for this seat.",
  "the_server_hasn_t_resolved_this_character_s_context_yet": "The server hasn't resolved this character's context yet.",
  "the_service_sends_json_or_text_to_the_webhook_url_the_input_r_b7a2a29f": "The service sends JSON or text to the webhook URL. The input reaches the agents as external data and does not answer their questions.",
  "their_assistant_is_already_here": "Their assistant is already here",
  "these_are_scheduled_messages_in_your_assistant_s_chat_you_can_a4326a26": "These are scheduled messages in your assistant's chat: you can also change their messages there, in its details.",
  "these_limits_apply_across_every_chat_this_assistant_leads": "These limits apply across every chat this assistant leads.",
  "these_limits_cover_all_agents_in_this_chat_s_team": "These limits cover all agents in this chat's team.",
  "these_settings_changed_review_the_current_values_and_your_cho_2d000b39": "These settings changed. Review the current values and your choices before saving again.",
  "they_can_t_bring_an_assistant_here_right_now": "They can't bring an assistant here right now.",
  "they_stop_directing_the_agents_and_won_t_get_new_messages": "They stop directing the agents and won't get new messages.",
  "this_agent_is_no_longer_in_the_chat": "This agent is no longer in the chat.",
  "this_agent_uses_the_library_character_s_current_texts_edit_th_e35fac4e": "This agent uses the library character's current texts. Edit the character in its library to change every agent using it.",
  "this_assistant_is_no_longer_available": "This assistant is no longer available.",
  "this_assistant_is_no_longer_in_the_chat": "This assistant is no longer in the chat.",
  "this_build_can_t_approve_event_changes_or_cancellations_chang_4d53c16c": "This build can't approve event changes or cancellations. Change the event yourself, then dismiss this suggestion.",
  "this_build_can_t_approve_this_items_change_make_it_yourself_i_c7ec769e": "This build can't approve this Items change. Make it yourself in Items, then dismiss this suggestion.",
  "this_change_was_cancelled_because_the_assistant_or_its_permis_84650baf": "This change was cancelled because the assistant or its permissions changed.",
  "this_character_isn_t_available": "This character isn't available",
  "this_chat_and_granted_private_home_context": "This chat and granted private-home context",
  "this_chat_and_this_project_s_files": "This chat and this project’s files",
  "this_chat_is_waiting_to_start_its_next_run": "This chat is waiting to start its next run.",
  "this_chat_only": "This chat only",
  "this_chat_or_project_is_no_longer_available": "This chat or project is no longer available.",
  "this_chat_project_files_and_granted_private_home_context": "This chat, project files and granted private-home context",
  "this_chat_uses_legacy_routing_hears_direction_and_role_notes_a5e39f9d": "This chat uses older routing. Hears, direction and role notes cannot be changed here.",
  "this_draft_isn_t_available": "This draft isn't available",
  "this_event_only": "This event only",
  "this_folder_holds_too_many_items_to_list_here_you_can_still_attach_it": "This folder holds too many items to list here. You can still attach it.",
  "this_isn_t_valid_json": "This isn't valid JSON.",
  "this_message_needs_a_newer_version_of_hylo": "This message needs a newer version of Hylo.",
  "this_project": "This project",
  "this_project_gets_a_folder_for_the_agent_s_work_when_the_chat_starts": "This project gets a folder for the agent’s work when the chat starts.",
  "this_section_changed_copy_your_json_before_reopening_it": "This section changed. Copy your JSON before reopening it.",
  "this_sends_invitations": "This sends invitations",
  "this_server_doesn_t_offer_agents_and_teams_yet": "This server doesn't offer Agents & Teams yet.",
  "this_specialist_isn_t_available_it_may_have_been_deleted": "This specialist isn't available. It may have been deleted.",
  "this_suggestion_isn_t_supported_by_this_app": "This suggestion isn't supported by this app.",
  "thread": "Thread",
  "time": "Time",
  "time_zone": "Time zone",
  "timers": "Timers",
  "times_are_in_the_schedule_s_time_zone_1_this_device_is_in_2": "Times are in the schedule's time zone, {{value1}}. This device is in {{value2}}.",
  "title": "Title",
  "today": "Today",
  "token_limits_use_reported_usage_when_a_run_starts_a_run_alrea_ddeb2be0": "Token limits use reported usage when a run starts. A run already working can exceed the limit.",
  "tokens": "{{value}} tokens",
  "tokens_339143": "tokens",
  "tokens_c38c6c": "Tokens",
  "tokens_per_day": "Tokens per day",
  "tokens_per_month": "Tokens per month",
  "tomorrow_at_9_00": "Tomorrow at 9:00",
  "too_long_1_lld_of_2_lld_bytes": "Too long: {{value1}} of {{value2}} bytes.",
  "too_long_1_lld_of_2_lld_characters": "Too long: {{value1}} of {{value2}} characters.",
  "too_long_to_send_1_lld_of_2_lld_characters": "Too long to send: {{value1}} of {{value2}} characters",
  "tools": "Tools",
  "totals_include_reported_values_only_model_time_adds_each_call_35404236": "Totals include reported values only. Model time adds each call's duration. Costs come from the engine and may be estimates.",
  "try_again": "Try Again",
  "try_again_042c86": "Try again",
  "try_other_words_or_filters": "Try other words or filters.",
  "turning_this_off_stops_all_active_exchanges_for_all_assistants_you_own": "Turning this off stops all active exchanges for all assistants you own.",
  "unavailable": "Unavailable",
  "unavailable_it_can_t_post_here": "Unavailable: it can't post here",
  "unavailable_its_person_can_t_post_here": "Unavailable: its person can't post here",
  "unavailable_the_engine_is_busy": "Unavailable: the engine is busy",
  "unit": "Unit",
  "unknown": "Unknown",
  "unknown_limit": "Unknown limit",
  "unknown_scope": "Unknown scope",
  "unknown_setting": "Unknown setting",
  "unlimited": "Unlimited",
  "unsupported_access": "Unsupported access",
  "unsupported_access_change": "Unsupported access change",
  "unsupported_agreement": "Unsupported agreement",
  "unsupported_event_time": "Unsupported event time",
  "unsupported_response": "Unsupported response",
  "unsupported_review": "This change cannot be fully reviewed in this version. You can dismiss it or open it in the App.",
  "unsupported_suggestion": "Unsupported suggestion",
  "untitled_chat": "Untitled chat",
  "up": "Up",
  "up_to_64_characters": "Up to 64 characters.",
  "up_to_lld_characters": "Up to {{count}} characters.",
  "update_hylo_to_review_this_budget_card": "Update Hylo to review this budget card.",
  "update_hylo_to_review_this_suggestion_it_can_t_be_approved_here": "Update Hylo to review this suggestion. It can't be approved here.",
  "updating_its_character": "Updating its character…",
  "upload": "Upload",
  "url": "URL",
  "usage": "Usage",
  "use_a_public_https_endpoint_hylo_sends_a_signed_event_with_a_d192308f": "Use a public HTTPS endpoint. Hylo sends a signed event with a bounded copy of the agent's text.",
  "use_account_name": "Use Account Name",
  "use_an_mention_or_reply_to_address_this_assistant_every_messa_e4c0cb35": "Use an @mention or reply to address this assistant. Every message also includes messages not addressed to someone else.",
  "use_at_least_lld_characters": "Use at least {{count}} characters.",
  "use_at_most_lld_characters": "Use at most {{count}} characters.",
  "use_its_skills": "Use its skills",
  "use_lld_characters_or_fewer": "Use {{count}} characters or fewer",
  "use_this_device_s_time_zone": "Use This Device's Time Zone",
  "use_this_key_to_verify_the_hmac_signature_of_incoming_hylo_ev_3a6d7aca": "Use this key to verify the HMAC signature of incoming Hylo events. Deliveries may be retried; deduplicate their delivery IDs.",
  "used_by": "Used by",
  "used_today": "Used Today",
  "uses_its_default_character": "Uses its default character",
  "values": "Values",
  "values_what_it_weighs": "Values: what it weighs",
  "versions": "Versions",
  "view": "View",
  "viewed_a_chat": "Viewed a chat",
  "voice": "Voice",
  "voice_who_it_is": "Voice: who it is",
  "waiting": "Waiting",
  "waiting_busy_in_other_chats": "Waiting: busy in other chats",
  "waiting_for_an_answer": "Waiting for an answer",
  "waiting_for_the_result_of_your_approved_change": "Waiting for the result of your approved change.",
  "waiting_for_this_assistant_s_home": "Waiting for this assistant’s home…",
  "waiting_for_you": "Waiting for you",
  "waiting_for_your_approval": "Waiting for your approval",
  "waiting_too_many_agents_running": "Waiting: too many agents running",
  "wake_up": "Wake-up",
  "webhook_secret": "Webhook Secret",
  "weekday_monday_1": "Weekday (Monday = 1)",
  "weekdays": "Weekdays",
  "weekly": "Weekly",
  "weekly_review": "Weekly Review",
  "weekly_review_7dd8f6": "Weekly review",
  "what_got_done_what_s_open_and_what_s_next_skipped_in_a_week_y_da193e92": "What got done, what's open, and what's next. Skipped in a week you didn't talk to it.",
  "what_it_does_in_a_line": "What it does, in a line",
  "what_it_hears": "What it hears",
  "what_it_knows_before_every_run": "What it knows before every run",
  "what_it_weighs": "What it weighs",
  "what_needs_your_attention_today_skipped_while_you_haven_t_use_801f2c13": "What needs your attention today. Skipped while you haven't used Hylo for 3 days.",
  "what_should_the_agents_do_then": "What should the agents do then?",
  "what_your_assistant_read_as_you_and_your_changes_to_its_acces_ad66e377": "What your assistant read as you, and your changes to its access, from the last 90 days. The log names chats and projects, never what they say.",
  "when": "When",
  "when_a_chat_starts": "When a chat starts",
  "when_addressed": "When addressed",
  "when_on_your_assistant_can_read_everything_you_can_your_chats_58f49a62": "When on, your assistant can read everything you can: your chats and their history, your projects and their files, your contacts and your organizations, and search them. It reads only in its own chat with you, never posts or reacts as you, and everything it reads is listed in the access log. Leave chats and projects out below. Turning this off stops it at once.",
  "when_on_your_assistant_can_read_everything_you_can_your_chats_67985c7b": "When on, your assistant can read everything you can: your chats and their history, your projects and their files, your contacts and your organizations, and search them. Choose below where it may read as you. It never posts or reacts as you, and everything it reads is listed in the access log. Leave chats and projects out below. Turning this off stops it at once.",
  "where_it_can_read_as_you": "Where it can read as you",
  "which_actions_wait_for_a_person_and_the_budgets_are_set_on_a_team": "Which actions wait for a person, and the budgets, are set on a team.",
  "who_can_add_people": "Who can add people",
  "who_directs_it_here": "Who directs it here",
  "who_directs_this_assistant": "Who directs this assistant",
  "who_it_is": "Who it is",
  "who_may_use_it": "Who may use it",
  "why": "Why",
  "withdraw": "Withdraw",
  "withdraw_or_decline_an_assistant_request": "Withdraw or decline an assistant request",
  "withdrew_a_suggestion": "Withdrew a suggestion",
  "within_the_scopes_memory_allows": "Within the scopes Memory allows.",
  "woken_by_a_message": "Woken by a message",
  "woken_by_a_timer": "Woken by a timer",
  "woken_by_an_event": "Woken by an event",
  "woken_by_someone_here": "Woken by someone here",
  "working": "Working",
  "working_folder": "Working folder",
  "write": "Write",
  "write_a_cron_expression": "Write a cron expression.",
  "write_a_skill": "Write a Skill…",
  "write_the_message_to_send": "Write the message to send.",
  "you_approved_a_suggestion": "You approved a suggestion",
  "you_approved_this_suggestion": "You approved this suggestion.",
  "you_are": "You are…",
  "you_aren_t_in_an_organization": "You aren't in an organization.",
  "you_asked_to_bring_their_assistant": "You asked {{value}} to bring their assistant",
  "you_can_have_up_to_lld_assistants_including_your_default_each_680a2792": "You can have up to {{count}} assistants, including your default. Each has its own memory and settings.",
  "you_can_require_approval_for_posts_in_chats_with_other_people_07e30389": "You can require approval for posts in chats with other people after the assistant used your private data in that run, or for every post. Its own posts appear as the assistant; a suggested reply you approve with Send as me is sent as you.",
  "you_changed_when_your_assistant_asks_before_posting": "You changed when your assistant asks before posting",
  "you_changed_where_your_assistant_can_read_as_you": "You changed where your assistant can read as you",
  "you_dismissed_a_suggestion": "You dismissed a suggestion",
  "you_dismissed_this_suggestion": "You dismissed this suggestion.",
  "you_left_a_chat_or_project_out": "You left a chat or project out",
  "you_let_it_read_a_chat_or_project_again": "You let it read a chat or project again",
  "you_paused_your_assistant": "You paused your assistant",
  "you_resumed_your_assistant": "You resumed your assistant",
  "you_turned_access_off": "You turned access off",
  "you_turned_access_on": "You turned access on",
  "your_assistant": "Your assistant",
  "your_assistant_also_wakes_for_these_on_its_own_in_its_chat_wi_587cac1e": "Your assistant also wakes for these on its own, in its chat with you. To stop it there, use Stop.",
  "your_assistant_b663ea": "your assistant",
  "your_assistant_can_exchange_messages_with_eligible_friends_an_e9afa929": "Your assistant can exchange messages with eligible friends' and org members' assistants. Sharing and commitments still need your approval.",
  "your_assistant_couldn_t_be_set_up_yet_its_home_project_is_arc_969ead2f": "Your assistant couldn't be set up yet: its home project is archived, or it isn't yours anymore. Restore it, then try again.",
  "your_assistant_couldn_t_be_set_up_yet_setting_it_up_hit_an_un_c70fef42": "Your assistant couldn't be set up yet: setting it up hit an unexpected error. Hylo keeps trying on its own, or you can try again now.",
  "your_assistant_couldn_t_be_set_up_yet_the_agent_engine_can_t_60152c94": "Your assistant couldn't be set up yet: the agent engine can't be reached right now. Hylo keeps trying on its own, or you can try again now.",
  "your_assistant_couldn_t_be_set_up_yet_the_agent_engine_refuse_4e9d1aad": "Your assistant couldn't be set up yet: the agent engine refused to create it and needs an update. You can try again once it's updated.",
  "your_assistant_couldn_t_be_set_up_yet_your_agent_chats_are_at_cded2f47": "Your assistant couldn't be set up yet: your agent chats are at their limit. Stop one of them, then try again.",
  "your_assistant_gets_a_short_list_of_what_happened_who_and_whe_2316f735": "Your assistant gets a short list of what happened: who and where, never the messages themselves. It reads them only with the access you give it.",
  "your_assistant_hasn_t_read_anything_as_you": "Your assistant hasn't read anything as you.",
  "your_assistant_is_an_ai_agent_of_your_own_it_works_in_its_own_5e7a22ba": "Your assistant is an AI agent of your own. It works in its own folder, where it keeps its memory (a profile, people, projects, commitments and a journal), and it reads Hylo only as far as you let it. It never sends anything in your name without your approval.",
  "your_assistant_isn_t_available_on_this_server": "Your assistant isn't available on this server.",
  "your_assistant_isn_t_in_any_chat_yet_bring_it_into_a_group_fr_850a0833": "Your assistant isn't in any chat yet. Bring it into a group from the group's info: Add My Assistant.",
  "your_assistant_isn_t_set_up_yet": "Your assistant isn't set up yet.",
  "your_assistant_isn_t_set_up_yet_once_it_is_you_choose_here_wh_0e113fc4": "Your assistant isn't set up yet. Once it is, you choose here what it may read.",
  "your_assistant_joins_this_chat_s_team_unaddressed_messages_go_e2629da3": "Your assistant joins this chat’s team. Unaddressed messages go to your default if it is here, otherwise your only assistant here. With several others, choose an @mention or reply.",
  "your_assistant_never_reads_these_as_you": "Your assistant never reads these as you.",
  "your_assistant_withdrew_this_suggestion": "Your assistant withdrew this suggestion.",
  "your_change_couldn_t_be_applied_review_the_current_settings_b_2f3aef5f": "Your change couldn't be applied. Review the current settings before trying again.",
  "your_change_was_applied": "Your change was applied.",
  "your_default_answers_when_you_don_t_choose_an_assistant_chang_fce8f504": "Your default answers when you don't choose an assistant. Changing it keeps every assistant's chats, memory and settings.",
  "your_own_ai_assistant_is_being_set_up_its_chat_will_appear_at_27354ad5": "Your own AI assistant is being set up. Its chat will appear at the top of Home in a moment.",
  "your_schedules_post_only_while_the_agents_run_is_live_the_cha_b95e0b5d": "Your schedules post only while the agents' run is live; the chat's creator restarts it.",
  "web_A new assistant starts with fresh memory and its own controls.": "A new assistant starts with fresh memory and its own controls.",
  "web_A new run uses the current settings and project files.": "A new run uses the current settings and project files.",
  "web_A private place to think, plan and get things done.": "A private place to think, plan and get things done.",
  "web_Access activity is kept for 90 days.": "Access activity is kept for 90 days.",
  "web_Add Exclusion": "Add Exclusion",
  "web_Add Project": "Add Project",
  "web_Add Schedule": "Add Schedule",
  "web_Agent Chat": "Agent Chat",
  "web_Agent Settings": "Agent Settings",
  "web_Agent collaboration": "Agent collaboration",
  "web_Agent note": "Agent note",
  "web_All": "All",
  "web_All outputs": "All outputs",
  "web_Already attached": "Already attached",
  "web_Applies to the next run in this assistant’s private home. Clearing does not erase historical prompts.": "Applies to the next run in this assistant’s private home. Clearing does not erase historical prompts.",
  "web_Approval": "Approval",
  "web_Assistant Requests": "Assistant Requests",
  "web_Assistant context": "Assistant context",
  "web_Assistant limit": "Assistant limit",
  "web_Attempts": "Attempts",
  "web_Back": "Back",
  "web_Brain": "Brain",
  "web_Browse": "Browse",
  "web_Captured context is a reference, not permission or proof that an action ran.": "Captured context is a reference, not permission or proof that an action ran.",
  "web_Change": "Change",
  "web_Change Model": "Change Model",
  "web_Change Photo": "Change Photo",
  "web_Changes may apply on the next run.": "Changes may apply on the next run.",
  "web_Character Library": "Character Library",
  "web_Choose": "Choose",
  "web_Choose Project": "Choose Project",
  "web_Community Publishing": "Community Publishing",
  "web_Copied": "Copied",
  "web_Copy Secret": "Copy Secret",
  "web_Couldn’t copy": "Couldn’t copy",
  "web_Couldn’t load the proposed photo.": "Couldn’t load the proposed photo.",
  "web_Couldn’t load. Check your connection and try again.": "Couldn’t load. Check your connection and try again.",
  "web_Create and edit specialists in the App’s Studio.": "Create and edit specialists in the App’s Studio.",
  "web_Cron": "Cron",
  "web_Current instructions": "Current instructions",
  "web_Daily Budget": "Daily Budget",
  "web_Day of week": "Day of week",
  "web_Delete": "Delete",
  "web_Delete Schedule?": "Delete Schedule?",
  "web_Delivery failed": "Delivery failed",
  "web_Download": "Download",
  "web_Edit Suggestion": "Edit Suggestion",
  "web_Exclusions do not remove an assistant’s own chat membership. Pause applies everywhere; Stop applies to one chat.": "Exclusions do not remove an assistant’s own chat membership. Pause applies everywhere; Stop applies to one chat.",
  "web_Expired": "Expired",
  "web_Expires": "Expires",
  "web_Five fields: minute hour day-of-month month day-of-week.": "Five fields: minute hour day-of-month month day-of-week.",
  "web_Full Roster": "Full Roster",
  "web_Grant Access": "Grant Access",
  "web_I have reviewed this photo": "I have reviewed this photo",
  "web_Interval (minutes)": "Interval (minutes)",
  "web_Left Out": "Left Out",
  "web_Let friends’ and organization members’ assistants reach mine.": "Let friends’ and organization members’ assistants reach mine.",
  "web_Listening and Direction": "Listening and Direction",
  "web_Load More Turns": "Load More Turns",
  "web_Meet your assistant": "Meet your assistant",
  "web_Member": "Member",
  "web_Message": "Message",
  "web_Next": "Next",
  "web_No agent team in this chat.": "No agent team in this chat.",
  "web_No agents available.": "No agents available.",
  "web_No assistants": "No assistants",
  "web_No chats": "No chats",
  "web_No connections": "No connections",
  "web_No deliveries": "No deliveries",
  "web_No exchanges": "No exchanges",
  "web_No exclusions": "No exclusions",
  "web_No matches": "No matches",
  "web_No projects": "No projects",
  "web_No recent activity": "No recent activity",
  "web_No runs": "No runs",
  "web_No schedules": "No schedules",
  "web_No specialists": "No specialists",
  "web_No suggestions": "No suggestions",
  "web_No turns": "No turns",
  "web_No usage yet": "No usage yet",
  "web_Not installed": "Not installed",
  "web_Notify Me About": "Notify Me About",
  "web_Only automated runs count toward this daily budget.": "Only automated runs count toward this daily budget.",
  "web_Only while running": "Only while running",
  "web_Open this agent from a chat to see its current settings.": "Open this agent from a chat to see its current settings.",
  "web_Parent Assistant": "Parent Assistant",
  "web_Pause Assistant": "Pause Assistant",
  "web_Previous": "Previous",
  "web_Project Root": "Project Root",
  "web_Project name": "Project name",
  "web_Publications": "Publications",
  "web_Publishing still requires the human preview and confirmation shown in Discover.": "Publishing still requires the human preview and confirmation shown in Discover.",
  "web_Question": "Question",
  "web_Read access": "Read access",
  "web_Read content": "Read content",
  "web_Reduce Access": "Reduce Access",
  "web_Reference": "Reference",
  "web_Refresh Connections": "Refresh Connections",
  "web_Refreshing…": "Refreshing…",
  "web_Remove Agent?": "Remove Agent?",
  "web_Remove Project?": "Remove Project?",
  "web_Removing": "Removing",
  "web_Reported status": "Reported status",
  "web_Restart this chat?": "Restart this chat?",
  "web_Result": "Result",
  "web_Review Agreement": "Review Agreement",
  "web_Review Suggestion": "Review Suggestion",
  "web_Review actions": "Review actions",
  "web_Review current settings": "Review current settings",
  "web_Review required": "Review required",
  "web_Review the current item context before approving.": "Review the current item context before approving.",
  "web_Revoke Connection?": "Revoke Connection?",
  "web_Role notes": "Role notes",
  "web_Routing": "Routing",
  "web_Run failed": "Run failed",
  "web_Run workspace": "Run workspace",
  "web_Save this credential now": "Save this credential now",
  "web_Search": "Search",
  "web_Search agents and teams": "Search agents and teams",
  "web_Secret": "Secret",
  "web_See All": "See All",
  "web_Send": "Send",
  "web_Set Up Assistant": "Set Up Assistant",
  "web_Setting up": "Setting up",
  "web_Setup failed": "Setup failed",
  "web_Show more": "Show more",
  "web_Skills & Brain": "Skills & Brain",
  "web_Some context was omitted.": "Some context was omitted.",
  "web_Specialist": "Specialist",
  "web_Standing Instructions": "Standing Instructions",
  "web_Start Chat": "Start Chat",
  "web_Stop Exchange?": "Stop Exchange?",
  "web_Stop has not been confirmed. Wait before restarting.": "Stop has not been confirmed. Wait before restarting.",
  "web_Stopping": "Stopping",
  "web_Studio Draft": "Studio Draft",
  "web_The agent stops and leaves. Adding it again starts fresh.": "The agent stops and leaves. Adding it again starts fresh.",
  "web_The chat was created. Refresh its details to confirm the remaining change.": "The chat was created. Refresh its details to confirm the remaining change.",
  "web_The list is incomplete. Refresh to try again.": "The list is incomplete. Refresh to try again.",
  "web_The result is uncertain. Refresh Connections before creating another one.": "The result is uncertain. Refresh Connections before creating another one.",
  "web_The server calculates the next occurrence in the selected time zone.": "The server calculates the next occurrence in the selected time zone.",
  "web_These settings are managed by the assistant’s owner or chat manager.": "These settings are managed by the assistant’s owner or chat manager.",
  "web_Thinking": "Thinking",
  "web_This agent is no longer in this chat.": "This agent is no longer in this chat.",
  "web_This connection is no longer available.": "This connection is no longer available.",
  "web_This connection will no longer deliver messages.": "This connection will no longer deliver messages.",
  "web_This context was captured by a newer version.": "This context was captured by a newer version.",
  "web_This draft isn’t available.": "This draft isn’t available.",
  "web_This folder has too many entries to list.": "This folder has too many entries to list.",
  "web_This is no longer available.": "This is no longer available.",
  "web_This schedule can only be edited in a newer version.": "This schedule can only be edited in a newer version.",
  "web_This secret is shown only once. Closing this window loses it.": "This secret is shown only once. Closing this window loses it.",
  "web_Total": "Total",
  "web_Tracing is unavailable or disabled for this run.": "Tracing is unavailable or disabled for this run.",
  "web_Turn": "Turn",
  "web_Unlimited leaves the cap unset. Zero holds new starts.": "Unlimited leaves the cap unset. Zero holds new starts.",
  "web_Usage Limits": "Usage Limits",
  "web_Usage periods use UTC calendar days. Missing or estimated reporting is shown separately.": "Usage periods use UTC calendar days. Missing or estimated reporting is shown separately.",
  "web_Use This Device’s Time Zone": "Use This Device’s Time Zone",
  "web_Use character": "Use character",
  "web_View Draft": "View Draft",
  "web_Your Assistant": "Your Assistant",
  "web_Your assistant has its own memory and controls.": "Your assistant has its own memory and controls.",
  "web_{{count}} references": "{{count}} references",
  "web_{{count}} skills": "{{count}} skills",
  "web_Save": "Save",
  "web_Cancel": "Cancel",
  "web_Approve": "Approve",
  "web_Dismiss": "Dismiss",
  "web_Decline": "Decline",
  "web_Edit": "Edit",
  "web_Done": "Done",
  "web_Continue once": "Continue once",
  "web_Raise the limit": "Raise the limit",
  "web_Read Items and Calendar": "Read Items and Calendar",
  "web_Write Own Items": "Write Own Items",
  "web_Require Item Approval": "Require Item Approval",
  "web_Allow Label Routing": "Allow Label Routing",
  "web_before": "before",
  "web_after": "after",
  "web_Send as me": "Send as me",
  "web_Send as assistant": "Send as assistant",
  "web_Memory files loaded by the CLI: Unknown": "Memory files loaded by the CLI: Unknown",
  "web_Apply Now": "Apply Now",
  "web_Choose a different agent": "Choose a different agent",
  "web_Unknown": "Unknown",
  "web_starting": "Starting",
  "web_idle": "Idle",
  "web_working": "Working",
  "web_waiting": "Waiting",
  "web_sleeping": "Sleeping",
  "web_stopping": "Stopping",
  "web_stopped": "Stopped",
  "web_ended": "Ended",
  "web_unavailable": "Unavailable",
  "web_pending": "Pending",
  "web_provisioning": "Setting up",
  "web_ready": "Ready",
  "web_deleting": "Deleting",
  "web_deleted": "Deleted",
  "web_removing": "Removing",
  "web_active": "Active",
  "web_revoked": "Revoked",
  "web_expired": "expired",
  "web_failed": "Failed",
  "web_cancelled": "Cancelled",
  "web_approved": "Approved",
  "web_dismissed": "Dismissed",
  "web_withdrawn": "Withdrawn",
  "web_declined": "Declined",
  "web_completed": "Completed",
  "web_queued": "Queued",
  "web_incoming": "Incoming",
  "web_outgoing": "Outgoing",
  "web_delivering": "Delivering",
  "web_delivered": "Delivered",
  "web_private_chat": "Private home only",
  "web_all_chats": "All chats I can read",
  "web_after_private_reads": "After private reads",
  "web_always": "Always",
  "web_read": "Read",
  "web_write": "Read and write",
  "web_addressed": "When addressed",
  "web_all": "All messages",
  "web_owner": "owner",
  "web_person": "Its person",
  "web_members": "members",
  "web_once": "Once",
  "web_interval": "Interval",
  "web_daily": "Daily",
  "web_weekdays": "Weekdays",
  "web_weekly": "Weekly",
  "web_cron": "Cron",
  "web_briefing": "Morning briefing",
  "web_distillation": "Memory distillation",
  "web_review": "Weekly review",
  "web_dm": "Direct messages",
  "web_mention": "Mentions",
  "web_reply": "Replies",
  "web_invitation": "Invitations",
  "web_file": "Files",
  "web_daily_runs": "Daily runs",
  "web_monthly_runs": "Monthly runs",
  "web_daily_tokens": "Daily tokens",
  "web_monthly_tokens": "Monthly tokens",
  "web_in_effect": "In effect",
  "web_next_run": "Next run",
  "web_unknown": "Unknown",
  "web_budget": "Budget",
  "web_schedule": "Schedule",
  "web_events": "Notifications",
  "web_messages": "messages",
  "web_references": "references",
  "web_bytes": "bytes",
  "web_post.draft": "Draft posts",
  "web_post.publish": "Publish posts",
  "web_post.edit": "Edit posts",
  "web_post.visibility": "Change post visibility",
  "web_post.delete": "Delete posts",
  "web_post.share": "Share posts",
  "web_comment.create": "Create comments",
  "web_comment.delete": "Delete comments",
  "web_discussion.manage": "Manage discussions",
  "web_relation.write": "Follow and block",
  "web_saved.read": "Read saved posts",
  "web_saved.write": "Manage saved posts",
  "web_activity.read": "Read community activity",
  "web_You can have up to {{count}} assistants, including your default. Each has its own memory and settings.": "You can have up to {{count}} assistants, including your default. Each has its own memory and settings.",
  "web_Your assistant can exchange messages with eligible friends’ and organization members’ assistants. Sharing and commitments still need your approval.": "Your assistant can exchange messages with eligible friends’ and organization members’ assistants. Sharing and commitments still need your approval.",
  "web_No teams available.": "No teams available.",
  "web_No characters available.": "No characters available.",
  "web_Add this agent from a chat’s roster.": "Add this agent from a chat’s roster.",
  "web_Evidence": "Evidence",
  "web_Model Calls": "Model Calls",
  "web_Runs": "Runs",
  "web_Tokens": "Tokens",
  "web_Model Time (ms)": "Model Time (ms)",
  "web_Cost (USD)": "Cost (USD)",
  "web_Unreported Tokens": "Unreported Tokens",
  "web_Unreported Time": "Unreported Time",
  "web_Unreported Cost": "Unreported Cost",
  "web_Estimated Calls": "Estimated Calls",
  "web_Pending Runs": "Pending Runs",
  "web_Unavailable Runs": "Unavailable Runs",
  "web_Used Today": "Used Today",
  "web_Waiting": "Waiting",
  "web_Resets": "Resets",
  "web_Count": "Count",
  "web_Action": "Action",
  "web_Scope": "Scope",
  "web_Target": "Target",
  "web_Target Kind": "Target Kind",
  "web_The run failed.": "The run failed.",
  "web_The engine lost this run.": "The engine lost this run.",
  "web_This run ended after being idle.": "This run ended after being idle.",
  "web_This run reached its message limit.": "This run reached its message limit.",
  "web_The assistant is paused.": "The assistant is paused.",
  "web_The project is unavailable.": "The project is unavailable.",
  "web_The engine is unavailable.": "The engine is unavailable.",
  "web_This chat is closed.": "This chat is closed.",
  "web_Last Turn is unavailable.": "Last Turn is unavailable.",
  "web_thinking": "thinking",
  "web_researching": "researching",
  "web_reading": "reading",
  "web_planning": "planning",
  "web_coding": "coding",
  "web_testing": "testing",
  "web_reviewing": "reviewing",
  "web_writing": "writing",
  "web_blocked": "blocked",
  "web_done": "done",
  "web_Submitted choices": "Submitted choices",
  "web_No accessible folders": "No accessible folders",
  "web_Listening settings are read only in legacy chats.": "Listening settings are read only in older chats.",
  "web_Offline. Showing the last available data.": "Offline. Showing the last available data.",
  "web_Resume Assistant Creation": "Resume Assistant Creation",
  "web_{{count}} skills_one": "{{count}} skill",
  "web_{{count}} skills_other": "{{count}} skills",
  "web_{{count}} references_one": "{{count}} reference",
  "web_{{count}} references_other": "{{count}} references",
  "web_Settings or run state changed. Refresh In effect to check current facts.": "Settings or run state changed. Refresh In effect to check current facts.",
  "web_Open File": "Open File",
  "web_Unsupported": "Unsupported",
  "web_No turns recorded in this run yet.": "No turns recorded in this run yet.",
  "support.title.asking": "{{agent}} is asking:",
  "support.title.unknown_screen": "{{agent}} is stuck on a screen Hylo doesn't recognize.",
  "support.title.home_incomplete": "{{agent}} in this realm hasn't finished its first-time setup. An operator must finish it.",
  "support.title.session_broken": "{{agent}}'s session broke and can't recover by itself.",
  "support.title.seat_divergence": "{{agent}} is paused in this chat, but its run is still going.",
  "support.action.not_now": "Not now",
  "support.action.dismiss": "Dismiss",
  "support.action.restart_assistant": "Restart assistant",
  "support.action.restart_run": "Restart run",
  "support.action.stop": "Stop",
  "support.action.stop_run": "Stop run",
  "support.action.resume": "Resume",
  "support.action.send_keys": "Send keys",
  "support.action.unknown": "Unsupported action",
  "support.screen.unknown": "This screen isn't recognized, so nothing from it is shown.",
  "support.screen.options_count": "Options: {{count}}",
  "support.state.ready": "Ready. Send a message to continue.",
  "support.state.escalated": "An operator has been asked.",
  "support.step.stopping": "Stopping…",
  "support.step.stop_unconfirmed": "Stop not yet confirmed",
  "support.step.starting": "Starting…",
  "support.step.resuming": "Resuming…",
  "support.step.unknown": "Working on it…",
  "support.sheet.title": "Confirm action",
  "support.sheet.realm": "Realm",
  "support.sheet.agent": "Agent",
  "support.sheet.session": "Session",
  "support.sheet.action": "Action",
  "support.sheet.keys": "Keys",
  "support.sheet.countdown": "Expires in {{count}} seconds",
  "support.sheet.ask_again": "Ask again",
  "support.sheet.recovery_message": "Message to send after it restarts",
  "support.error.stale_target": "The screen changed. Review it and ask again.",
  "support.error.not_blocked": "This agent is no longer blocked.",
  "support.error.expired": "This request expired. Ask again.",
  "support.error.already_consumed": "This request was already used. The status has been refreshed.",
  "support.error.busy": "Another action is in progress. Try again when it finishes.",
  "support.error.not_authorized": "You no longer have permission to do this.",
  "support.error.dangerous_screen": "This screen asks for a credential or code. Only Dismiss is allowed.",
  "support.error.invalid_keys": "These keys can't be sent to this screen.",
  "support.error.no_session": "This agent has no session to recover.",
  "support.error.unsupported_engine": "This agent engine doesn't support screen recovery yet.",
  "support.error.engine_unavailable": "The agent engine is unavailable. Try again later.",
  "support.key.enter": "Enter",
  "support.key.esc": "Esc",
  "support.key.up": "Up",
  "support.key.down": "Down",
  "support.key.left": "Left",
  "support.key.right": "Right",
  "support.key.tab": "Tab",
  "support.flag.dangerous": "Asks for a credential or code. It will never be filled.",
  "support.engine.unsupported": "This agent engine doesn't support screen recovery yet.",
  "support.stuck.others": "This agent is stuck.",
  "support.action.show_screen": "Show screen",
  "support.action.cancel": "Cancel",
  "support.error.failed": "The action failed. Try again.",
  "support.sheet.continue": "Continue",
  "support.sheet.edit_message": "Edit",
  "web_Stuck on a screen in its AI tool": "Stuck on a screen in its AI tool",
  "web_Stuck on a screen in its AI tool.": "Stuck on a screen in its AI tool.",
  "web_Stuck on an unexpected screen in its AI tool": "Stuck on an unexpected screen in its AI tool",
  "web_Stuck on an unexpected screen in its AI tool.": "Stuck on an unexpected screen in its AI tool.",
  "web_Its AI tool hasn't finished first-time setup": "Its AI tool hasn't finished first-time setup",
  "web_Its AI tool hasn't finished first-time setup. An admin needs to fix this.": "Its AI tool hasn't finished first-time setup. An admin needs to fix this.",
  "web_Its AI tool needs to be signed in again": "Its AI tool needs to be signed in again",
  "web_Its AI tool needs to be signed in again. An admin needs to fix this.": "Its AI tool needs to be signed in again. An admin needs to fix this.",
  "web_Couldn't confirm the previous session stopped": "Couldn't confirm the previous session stopped",
  "web_Couldn't confirm the previous session stopped. An admin needs to check it.": "Couldn't confirm the previous session stopped. An admin needs to check it.",
  "web_agent": "agent",
  "web_Skills": "Skills",
  "web_Agent definition skills are configured for the next run. Installed with Hylo shows the bundled catalog; loaded skills may differ.": "Agent definition skills are configured for the next run. Installed with Hylo shows the bundled catalog; loaded skills may differ.",
  "web_The Installed with Hylo catalog describes bundled skills. Live installation and loaded skills may differ.": "The Installed with Hylo catalog describes bundled skills. Live installation and loaded skills may differ.",
  "web_Loading skills…": "Loading skills…",
  "web_This server does not support skill lists yet.": "This server does not support skill lists yet.",
  "web_Couldn't load skills.": "Couldn't load skills.",
  "web_The Installed with Hylo catalog is unavailable.": "The Installed with Hylo catalog is unavailable.",
  "web_Skill registry is not available on this server yet.": "Skill registry is not available on this server yet.",
  "web_Skill registry is temporarily unavailable.": "Skill registry is temporarily unavailable.",
  "web_The skill list is incomplete.": "The skill list is incomplete.",
  "web_No skill metadata is available.": "No skill metadata is available.",
  "web_No skills configured for this agent.": "No skills configured for this agent.",
  "web_No installed skills found.": "No installed skills found.",
  "web_Installed with Hylo": "Installed with Hylo",
  "web_Skill registry": "Skill registry",
  "web_Skill source unknown": "Skill source unknown",
  "web_Available": "Available",
  "web_, ": ", ",
  "web_Installed Skills": "Installed Skills",
  "web_Close": "Close",
  "web_Confirm": "Confirm",
  "web_admin": "admin",
  "web_You have unsaved changes.": "You have unsaved changes.",
  "web_Discard": "Discard",
  "web_Definition settings": "Definition settings",
  "web_Editing as admin": "Editing as admin",
  "web_The owner can see this change.": "The owner can see this change.",
  "web_Reload": "Reload",
  "web_Discard draft": "Discard draft",
  "web_References": "References",
  "web_File name": "File name",
  "web_Version": "Version",
  "web_When to use it": "When to use it",
  "web_Body (Markdown)": "Body (Markdown)",
  "web_New Skill": "New Skill",
  "web_New Reference": "New Reference",
  "web_handle": "handle",
  "web_Instructions": "Instructions",
  "web_Tools & CLIs": "Tools & CLIs",
  "web_CLIs": "CLIs",
  "web_Wakes": "Wakes",
  "web_Autonomy": "Autonomy",
  "web_This agent's account isn't available for project mounts yet.": "This agent's account isn't available for project mounts yet.",
  "web_The current run ends. A new run starts when there's a message for it, and it reads this chat so far.": "The current run ends. A new run starts when there's a message for it, and it reads this chat so far.",
  "web_It hasn't stopped yet. Tap Restart again once it has.": "It hasn't stopped yet. Tap Restart again once it has.",
  "web_The run changed. Refresh and try again.": "The run changed. Refresh and try again.",
  "web_Restart {{name}}?": "Restart {{name}}?",
  "web_Restart ends a stuck run and starts a new one; {{name}} stays on. Stop keeps {{name}} stopped here until you resume it.": "Restart ends a stuck run and starts a new one; {{name}} stays on. Stop keeps {{name}} stopped here until you resume it.",
  "web_{{name}} is stopped": "{{name}} is stopped",
  "web_Manage Agents": "Manage Agents",
  "web_Review changes": "Review changes",
  "web_Link a document": "Link a document",
  "web_Linked documents stay read-only here. Edit the original to change every agent using it.": "Linked documents stay read-only here. Edit the original to change every agent using it.",
  "web_Save publishes a new version. Chats pick it up on their next run.": "Save publishes a new version. Chats pick it up on their next run.",
  "web_Your local changes will be discarded.": "Your local changes will be discarded.",
  "web_Permissions": "Permissions",
  "web_Triggers": "Triggers",
  "web_Team settings": "Team settings",
  "web_Session settings": "Session settings",
  "web_Validation": "Validation",
  "web_Publication": "Publication",
  "web_instance": "Instance",
  "web_class": "Class",
  "web_team_run": "Run",
  "web_project": "Project",
  "web_exec": "Full",
  "web_none": "None",
  "web_System skills": "System skills",
  "web_Ready": "Ready",
  "web_Working": "Working",
  "web_Starting…": "Starting…",
  "web_Stopping…": "Stopping…",
  "web_Stopped": "Stopped",
  "web_Ended": "Ended",
  "web_Waiting for you": "Waiting for you",
  "web_Sleeping": "Sleeping",
  "web_Unavailable": "Unavailable",
  "web_Assistant": "Assistant",
  "web_Refresh": "Refresh",
  "web_Try Again": "Try Again",
  "web_Resume": "Resume",
  "web_Show": "Show",
  "web_Agents": "Agents",
  "web_Teams": "Teams",
  "web_Agent": "Agent",
  "web_Team": "Team",
  "web_Load more": "Load more",
  "web_Agent Definition": "Agent Definition",
  "web_Loading…": "Loading…",
  "web_These settings changed. Review the current values and your choices before saving again.": "These settings changed. Review the current values and your choices before saving again.",
  "web_Duplicate": "Duplicate",
  "web_Name": "Name",
  "web_Remove": "Remove",
  "web_Identity": "Identity",
  "web_Handle": "Handle",
  "web_Role": "Role",
  "web_Bio": "Bio",
  "web_Character": "Character",
  "web_Choose from Character Library…": "Choose from Character Library…",
  "web_Custom": "Custom",
  "web_Start from a character": "Start from a character",
  "web_This agent uses the library character's current texts. Edit the character in its library to change every agent using it.": "This agent uses the library character's current texts. Edit the character in its library to change every agent using it.",
  "web_Voice": "Voice",
  "web_Values": "Values",
  "web_Speech": "Speech",
  "web_Leans to effort": "Leans to effort",
  "web_None": "None",
  "web_Role prompt (Markdown)": "Role prompt (Markdown)",
  "web_Memory": "Memory",
  "web_Role guidance": "Role guidance",
  "web_Heuristics": "Heuristics",
  "web_Read": "Read",
  "web_Write": "Write",
  "web_Tools": "Tools",
  "web_Execution": "Execution",
  "web_Projects": "Projects",
  "web_The class as claw runs it": "The class as claw runs it",
  "web_Edit JSON": "Edit JSON",
  "web_This section changed. Copy your JSON before reopening it.": "This section changed. Copy your JSON before reopening it.",
  "web_This isn't valid JSON.": "This isn't valid JSON.",
  "web_Apply": "Apply",
  "web_Restart": "Restart",
  "web_Stop": "Stop",
  "web_Add Agent": "Add Agent",
  "web_Run": "Run",
  "web_Assistants": "Assistants",
  "web_Schedules": "Schedules",
  "web_Connections": "Connections",
  "web_Agent Usage": "Agent Usage",
  "web_Runs and Traces": "Runs and Traces",
  "web_Project": "Project",
  "web_Browse Files": "Browse Files",
  "web_Project Memory": "Project Memory",
  "web_Activity": "Activity",
  "web_Pending": "Pending",
  "web_Leader": "Leader",
  "web_Joins when the leader brings it in": "Joins when the leader brings it in",
  "web_Bring into the chat now": "Bring into the chat now",
  "web_In Chats": "In Chats",
  "web_Name in this chat": "Name in this chat",
  "web_Working folder": "Working folder",
  "web_What it hears": "What it hears",
  "web_Who directs it here": "Who directs it here",
  "web_Settings": "Settings",
  "web_In effect": "In effect",
  "web_Session": "Session",
  "web_Restart this chat to add agents": "Restart this chat to add agents",
  "web_Add": "Add",
  "web_Choose Assistant": "Choose Assistant",
  "web_Not Now": "Not Now",
  "web_Withdraw": "Withdraw",
  "web_Read only": "Read only",
  "web_Installed in claw": "Installed in claw",
  "web_Write a Skill…": "Write a Skill…",
  "web_Description": "Description",
  "web_Members": "Members",
  "web_Move up": "Move up",
  "web_Move down": "Move down",
  "web_Skipped: not @mentioned or replied to": "Skipped: not @mentioned or replied to"
}
